window.OSM = window.OSM ?? {};
/**
 * @type {IMapsProps}
 */
OSM.MapConfigs = OSM.MapConfigs ?? {}

/**
 * See MapCoreConfig.js for working example
 * @type {IMapProps}
 */
OSM.MapConfigs.property_search = {
    preferredMapFocus: "defined",
    mapOptions: {
        container: "",
        center: [-6.8051389, 54.6678547],
        zoom: 7
    },
    cluster: {


        marker: {
            lngLat: [0, 0],
            iconProps: {
                imagePath: "/app/themes/hailstone/img/layout/property-marker.png",
                imageIconOrigin: [0, 0]
            }
        },
        clusterIcon: {
            /**
             *
             * @param itemCount {number}
             */
            getColor: (itemCount) =>
            {
                if(itemCount >= 10){
                    return "#202a44"
                }
                return "#E87722"
            },
            /**
             *
             * @param itemCount {number}
             */
            getStrokeColor: (itemCount) =>
            {
                if(itemCount >= 10){
                    return "#0e162b"
                }
                return "#a8510f"
            },
            /**
             *
             * @param itemCount {number}
             */
            getTextColor: (itemCount) =>
            {
                if(itemCount >= 10){
                    return "#ffffff"
                }
                return "#494229"
            }
        }
    }
}
